<template>
  <section v-if="activeDwelling" class="row">
    <language-selector />
    <card>
      <div class="d-flex flex-wrap">
        <div class="col-12 mb-4">
          <div class="row">
            <div class="col-12">
              <h3>Editing {{ activeDwelling.label }}</h3>
              <button class="btn btn-sm btn-primary" @click="viewAll">
                View All Dwellings
              </button>
              <button
                class="btn btn-sm btn-primary ml-1"
                @click="saveDwelling(activeDwelling)"
              >
                Save
              </button>
            </div>
          </div>
        </div>
        <div class="col-6 mb-4">
          <div class="row">
            <div class="col-6 mb-4">
              Label
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.label"
              />
            </div>
            <div class="col-6 mb-4">
              Display Name
              <localised-field-indicator />
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.displayName[activeLanguage.code]"
              />
            </div>
            <div class="col-6 mb-4">
              Dwelling Type
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.type"
              />
            </div>
            <div class="col-6 mb-4">
              Bedrooms
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.beds"
              />
            </div>
            <div class="col-6 mb-4">
              Bathrooms
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.baths"
              />
            </div>
            <div class="col-6 mb-4">
              Living Rooms
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.livingRooms"
              />
            </div>
            <div class="col-6 mb-4">
              Car Spaces
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.cars"
              />
            </div>
            <div class="col-6 mb-4">
              Dwelling Size (m<sup>2</sup>)
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.size"
              />
            </div>
            <div class="col-6 mb-4">
              House Width (m)
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.houseWidth"
              />
            </div>
            <div class="col-6 mb-4">
              Minimum Frontage Width (m)
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.minimumFrontageWidth"
              />
            </div>
            <div class="col-6 mb-4">
              Price
              <input
                type="text"
                class="form-control"
                :value="activeDwelling.price"
                @input="
                  (event) =>
                    (activeDwelling.price = event.target.value.replace(
                      /[^0-9.]/g,
                      ''
                    ))
                "
              />
            </div>
            <div class="col-6 mb-4">
              Virtual Tour URL
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.virtualTourUrl"
              />
            </div>
            <div v-if="activeDwelling.priceVisibility" class="col-12 mb-4">
              Price Visibility

              <div class="row">
                <div class="col-12 col-md-6">
                  <label for="">Touchscreen</label>
                  <toggle-button
                    v-model="activeDwelling.priceVisibility.touch"
                    :color="{ checked: '#28a745', unchecked: '#b8b8b8' }"
                    :sync="true"
                    :width="30"
                    :height="20"
                  />
                </div>

                <div class="col-12 col-md-6">
                  <label for="">Favourites</label>
                  <toggle-button
                    v-model="activeDwelling.priceVisibility.favourites"
                    :color="{ checked: '#28a745', unchecked: '#b8b8b8' }"
                    :sync="true"
                    :width="30"
                    :height="20"
                  />
                </div>

                <div class="col-12 col-md-6">
                  <label for="">Webfeed</label>
                  <toggle-button
                    v-model="activeDwelling.priceVisibility.webconnect"
                    :color="{ checked: '#28a745', unchecked: '#b8b8b8' }"
                    :sync="true"
                    :width="30"
                    :height="20"
                  />
                </div>

                <div class="col-12 col-md-6">
                  <label for="">WebX</label>
                  <toggle-button
                    v-model="activeDwelling.priceVisibility.webx"
                    :color="{ checked: '#28a745', unchecked: '#b8b8b8' }"
                    :sync="true"
                    :width="30"
                    :height="20"
                  />
                </div>
              </div>
            </div>

            <div class="col-12 mb-4">
              Description
              <localised-field-indicator />
              <ck-editor
                id="dwellingDescription"
                v-model="activeDwelling.description[activeLanguage.code]"
                :dir="activeLanguage.rtl ? 'rtl' : 'ltr'"
                :key="activeLanguage.code"
                :language="activeLanguage.code"
              />
            </div>
            <div class="col-12 mb-4">
              Feature List
              <localised-field-indicator />
              <ck-editor
                id="dwellingFeatureList"
                v-model="activeDwelling.featureList[activeLanguage.code]"
                :dir="activeLanguage.rtl ? 'rtl' : 'ltr'"
                :key="activeLanguage.code"
                :language="activeLanguage.code"
              />
            </div>
            <div class="col-12 mb-4">
              Is visible on webfeed?
              <info-box>
                If selected the dwelling will be visible in the dwelling listing
                page and on the webfeed.
              </info-box>
              <br />
              <toggle-button
                v-model="activeDwelling.isVisibleOnWebfeed"
                :color="{ checked: '#28a745', unchecked: '#b8b8b8' }"
                :sync="true"
                :width="30"
                :height="20"
              />
            </div>
          </div>
        </div>

        <div class="col-6 mb-4">
          <div class="row">
            <div v-if="activeDwelling.outlookImages" class="col-12 mb-4">
              Outlook Images
              <input-asset
                v-model="activeDwelling.outlookImages"
                key="outlook-images"
                :multiple="true"
              />
            </div>
            <div v-if="activeDwelling.facadeImages" class="col-12 mb-4">
              Facade Images
              <input-asset
                v-model="activeDwelling.facadeImages"
                key="facade-images"
                :allowed-extensions="['jpg', 'jpeg', 'png']"
                :multiple="true"
              />
            </div>
            <div v-if="activeDwelling.miscImages" class="col-12 mb-4">
              Misc Images
              <input-asset
                v-model="activeDwelling.miscImages"
                key="misc-images"
                :multiple="true"
              />
            </div>
            <div class="col-12 mb-4">
              Gallery Images
              <input-asset
                v-model="activeDwelling.galleryImages"
                key="gallery-images"
                :multiple="true"
              />
            </div>
            <div class="col-12 mb-4">
              Overlay Image
              <input-asset
                v-model="activeDwelling.overlayImage"
                key="overlay-image"
                :multiple="false"
              />
            </div>
            <div class="col-12 mb-4">
              iFrames
              <input-key-value-pairs
                class="form-control form-control-lg"
                key-label="label"
                value-label="url"
                v-model="activeDwelling.iframes"
              ></input-key-value-pairs>
            </div>
            <div class="col-12 mb-4">
              Floorplan Images
              <localised-field-indicator />
              <input-asset
                v-model="activeDwelling.floorplanImages[activeLanguage.code]"
                key="floorplan-images"
                :multiple="true"
              />
            </div>
            <div class="col-12 mb-4">
              PDFs
              <input-asset
                v-model="activeDwelling.pdfs"
                key="pdfs"
                :multiple="true"
                defaultCategory="misc"
              />
            </div>
            <div class="col-12 mb-4">
              Builder Label
              <localised-field-indicator />
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.builderLabel[activeLanguage.code]"
              />
            </div>
            <div class="col-12 mb-4">
              Builder Logo
              <input-asset
                v-model="activeDwelling.builderImage"
                key="builder-image"
              />
            </div>
            <div class="col-12 mb-4">
              Builder Description
              <localised-field-indicator />
              <ck-editor
                id="builderDescription"
                v-model="activeDwelling.builderDescription[activeLanguage.code]"
                :dir="activeLanguage.rtl ? 'rtl' : 'ltr'"
                :key="activeLanguage.code"
                :language="activeLanguage.code"
              />
            </div>
            <div class="col-12 mb-4">
              Builder URL
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.builderUrl"
              />
            </div>
            <div class="col-12 mb-4">
              House Design
              <localised-field-indicator />
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.houseDesign[activeLanguage.code]"
              />
            </div>
            <div class="col-12 mb-4">
              Colour Scheme
              <localised-field-indicator />
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.colourScheme[activeLanguage.code]"
              />
            </div>
          </div>
        </div>
      </div>
    </card>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import CkEditor from "@/components/CKEditor";
import InfoBox from "@/components/InfoBox";
import InputAsset from "@/components/InputAsset";
import InputKeyValuePairs from "@/components/InputKeyValuePairs";
import InputMultiSelect from "@/components/InputMultiSelect";

export default {
  components: {
    CkEditor,
    InfoBox,
    InputAsset,
    InputKeyValuePairs,
    InputMultiSelect,
  },

  data() {
    return {
      editingDwelling: null,
      activeDwellingId: null,
    };
  },

  computed: {
    ...mapGetters(["activeLanguage", "dwellings"]),

    activeDwelling() {
      if (this.editingDwelling) return this.editingDwelling;
      return this.dwellings.find(
        (dwelling) => dwelling._id === this.activeDwellingId
      );
    },
  },

  created() {
    this.$store.dispatch("FETCH_ASSETS");
    this.$store.dispatch("FETCH_DWELLINGS").then(() => {
      if (!this.editingDwelling) {
        this.editingDwelling = this.activeDwelling;
      }
    });
  },

  mounted() {
    this.activeDwellingId = this.$route.params.id;
    this.editingDwelling = this.activeDwelling;
  },

  methods: {
    viewAll() {
      this.$router.push("/live/dwellings");
    },

    saveDwelling(dwelling) {
      this.$store.dispatch("SAVE_DWELLING", dwelling);
      this.viewAll();
    },
  },
};
</script>
